import React, {
  useState,
  useCallback,
  useMemo,
} from 'react';
import {
  StickyContainer,
  Sticky,
} from 'react-sticky';
import {
  withRouter,
  RouteComponentProps,
} from 'react-router-dom';

import Waypoint from 'react-waypoint';
import Buttonlet from 'components/Buttonlet';
import ScrollNav from 'components/ScrollNav';
import MediaXlUp from 'components/Responsive/MediaXlUp';
import scrollToComponent from 'utils/scrollToComponent';

import HelpGroup from './components/HelpGroup';

import {
  HELP_ITEMS,
  HelpSection,
} from './helpItems';

function Help(props: RouteComponentProps) {
  const { history } = props;

  const [activeItem, setActiveItem] = useState<number | null>(null);

  const gotoItem = useCallback((item: HelpSection) => {
    setActiveItem(item.id);

    const el = document.querySelector(`[data-section-name="${item.name}"]`);
    if (el) {
      scrollToComponent(el, { offset: 0, align: 'top' });
    }
  }, []);

  const trackPosition = useCallback((item: HelpSection) => {
    setActiveItem(item.id);
  }, []);

  const helpItems = useMemo(() => HELP_ITEMS.map((helpItem, i) => ({ ...helpItem, id: i + 1 })), []);

  const helpGroups = useMemo(
    () => {
      if (!helpItems?.length) {
        return null;
      }

      return helpItems.map(helpGroup => (
        <div key={helpGroup.name}>
          <hr />
          <Waypoint
            onEnter={() => trackPosition(helpGroup)}
            scrollableAncestor={window}
            bottomOffset="70%"
          />
          <HelpGroup data={helpGroup} />
        </div>
      ));
    },
    [helpItems, trackPosition],
  );

  return (
    <div className="content container">
      <div className="col-primary col-primary--full">
        <h1
          className="heading heading--1"
          style={{ marginTop: 5 }}
        >
          <button
            className="button--link"
            onClick={() => { history.goBack(); }}
            style={{
              marginRight: '1rem',
            }}
            type="button"
          >
            <i className="fa fa-arrow-left back-button" />
          </button>
          Help
        </h1>
        <h2 className="heading heading--2">Welcome to Fallen London!</h2>
        <div>
          <p>
            You may be disoriented by the shock of your arrival. We’re here to help.
            {' '}
            <a
              href="https://community.failbettergames.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Our forums
            </a>
            {' '}
            and
            {' '}
            <a
              href="https://discordapp.com/invite/59aNpKf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Official Discord
            </a>
            {' '}
            are also a good place to seek assistance. And if you think you've found a bug,
            please let us know by emailing
            {' '}
            <a href="mailto:support@failbettergames.com">support@failbettergames.com</a>
            .
          </p>
          <Buttonlet
            type="book"
            title="Blog"
            onClick={() => window.open('http://www.failbettergames.com/news/', '_blank')}
          />
          <Buttonlet
            type="twitter"
            title="Twitter"
            onClick={() => window.open('https://www.twitter.com/echobazaar', '_blank')}
          />
          <Buttonlet
            type="facebook"
            title="Facebook"
            onClick={() => window.open('http://www.facebook.com/fallenlondon', '_blank')}
          />
          <Buttonlet
            type="quote-left"
            title="Forums"
            onClick={() => window.open('http://community.failbettergames.com', '_blank')}
          />
        </div>
        <br />
        <br />
        <br />
        <StickyContainer
          style={{ height: 'auto' }}
          className="row"
        >
          <MediaXlUp>
            <div className="nav nav--stacked nav--stacked--1-of-4 nav--stacked--roman">
              <Sticky>
                {
                  ({ style }) => (
                    <ScrollNav
                      style={style}
                      data={helpItems}
                      gotoItem={gotoItem}
                      active={activeItem}
                    />
                  )
                }
              </Sticky>
            </div>
          </MediaXlUp>
          <div className="stack-content stack-content--3-of-4">
            {helpGroups}
          </div>
        </StickyContainer>
        <p>...thank you. Delicious friend.</p>
      </div>
    </div>
  );
}

export default withRouter(Help);
